module.exports = __webpack_public_path__ + "img/b29608e.svg";